import Auctions from './Auctions';
import AuctionList from './AuctionList';

export default Auctions;

export {
    AuctionList,
};


// WEBPACK FOOTER //
// ./src/components/view/Auctions/index.js